<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula Fundamental
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5 d-flex" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
            <template v-if="!gestaoDeAula.is_polivalencia">
              <h4>Componente Curricular: {{ gestaoDeAula.disciplina?.descricao }}</h4>
            </template>
            <template v-else>
              <h4>Componentes Curriculares:</h4>
              <div class="container">
                <div class="row">
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip class="ml-2" x-small>{{ item?.descricao }} </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno?.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-if="etapas" ref="observer">
      <form @submit.prevent="onFormSubmit" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="mb-4">
                <e-label>
                  Etapas
                  <e-chips-extensao-etapa :etapa="etapaSelecionada" />
                </e-label>
              </div>

              <!-- <e-autocomplete
                v-if="editing"
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item?.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
                disabled
              /> -->

              <e-autocomplete
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item?.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
                class="mt-2"
              />
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-btn
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none mt-8"
              @click="() => criarPedido(etapaSelecionada.id)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>
        <div v-if="etapaSelecionada && etapaBloqueada == false">
          <v-row>
            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Aula</e-label>
                <e-autocomplete
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                  class="mt-2"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col class="pt-0 pb-0" cols="4">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                    <e-label>Selecione uma data</e-label>
                    <v-text-field
                      v-model="aulaSelecionada.data"
                      persistent-hint
                      :disabled="!aulaSelecionada.tipo_de_aula"
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </template>

                <v-card>
                  <v-container class="calendar-container">
                    <v-row>
                      <!-- Calendário -->
                      <v-col cols="12" md="12" class="d-flex justify-center">
                        <v-card class="calendar-card pa-3" elevation="2" outlined>
                          <v-date-picker
                            v-model="data"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDates"
                            :events="todosEventos.map((e) => e.data)"
                            :event-color="getBadgeColor"
                            @update:picker-date="atualizarMesVisivel"
                            color="primary"
                            header-color="primary"
                          >
                            <template v-slot:day="{ date, day }">
                              <v-badge
                                :color="getBadgeColor(date)"
                                :content="getBadgeContent(date)"
                                overlap
                                dot
                              >
                                <span :class="{ 'font-weight-bold': isToday(date) }">{{
                                  day
                                }}</span>
                              </v-badge>
                            </template>
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <!-- Lista de eventos -->
                      <v-col cols="12" md="12">
                        <v-card class="events-card" elevation="2" outlined>
                          <v-card-title class="primary white--text pa-4">
                            <v-icon left color="white">mdi-calendar-month</v-icon>
                            Eventos do Mês
                          </v-card-title>

                          <v-divider></v-divider>

                          <v-list dense class="py-0">
                            <template v-for="(evento, index) in eventosFiltradosPorMes">
                              <v-divider v-if="index > 0" :key="`divider-${index}`"></v-divider>
                              <v-list-item class="px-4" :key="`evento-${index}`">
                                <v-list-item-icon class="mr-3">
                                  <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="d-flex align-center">
                                    <span class="date-label mr-2">{{
                                      formatarDia(evento.data)
                                    }}</span>
                                    <span>
                                      {{ evento.descricao }}
                                      <v-chip
                                        v-if="
                                          evento.is_sabado_letivo === true ||
                                          evento.is_sabado_letivo === 1
                                        "
                                        x-small
                                        color="green"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia Letivo
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        x-small
                                        color="red"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia não letivo
                                      </v-chip>
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>

                            <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                              <v-list-item-content>
                                <v-list-item-title class="text-caption grey--text">
                                  Nenhum evento neste mês
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions class="dialog-actions">
                    <v-btn text color="primary" @click="modal = false"> Cancelar </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(data)"> OK </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col class="pt-0 pb-0" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'" cols="4">
              <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                <e-label>Selecione os horários</e-label>
                <v-alert v-if="!gestaoDeAula.turma.turno_id" class="pa-1" type="error" border="left"
                  >Essa turma está sem turno cadastrado, por favor, edite a turma e selecione um
                  turno para ela.</v-alert
                >
                <e-autocomplete
                  v-else
                  :disabled="!aulaSelecionada.data"
                  :items="horarios"
                  :error-messages="errors"
                  :label="editing ? 'Horário da aula' : 'Selecione uma ou mais opções'"
                  :item-text="(item) => item?.descricao"
                  v-model="horarioSelecionado"
                  :multiple="!editing"
                  chips
                  return-object
                  dense
                  @change="() => pesquisaAulas()"
                  :clearable="!editing"
                />
              </ValidationProvider>
            </v-col>

            <v-col class="pt-8 pb-0" cols="2" v-if="quantidadeNecessariaParaReplicar() && !editing">
              <e-label>Replicar Conteúdo </e-label>
              <e-help-tooltip class="pt-4" :text="$constants.tooltips.aulas.replicarAula" />
            </v-col>

            <v-col class="pt-4 pb-0" cols="2" v-if="quantidadeNecessariaParaReplicar() && !editing">
              <v-switch v-model="aulaSelecionada.replicar_conteudo"></v-switch>
            </v-col>

            <v-col
              cols="12"
              v-if="
                (Array.isArray(horarioSelecionado)
                  ? horarioSelecionado.length > 0
                  : !!horarioSelecionado) ||
                aulaSelecionada.tipo_de_aula === 'Aula Remota' ||
                editing
              "
            >
              <v-tabs
                v-if="
                  horarioSelecionado.length > 1 && !aulaSelecionada.replicar_conteudo && !editing
                "
                v-model="activeTab"
                background-color="transparent"
                color="primary"
                grow
              >
                <v-tab v-for="h in horarioSelecionado" :key="h.id">
                  {{ h.descricao }}
                </v-tab>
              </v-tabs>

              <v-tabs-items
                v-model="activeTab"
                v-if="
                  horarioSelecionado.length > 1 && !aulaSelecionada.replicar_conteudo && !editing
                "
              >
                <v-tab-item v-for="h in horariosComDados" :key="h.id" eager>
                  <div class="pa-4">
                    <div v-if="gestaoDeAula.is_polivalencia && dadosAulas[h.id]">
                      <e-label>Selecione as Disciplinas dessa Aula ({{ h.descricao }})</e-label>
                      <div class="container">
                        <div class="row">
                          <v-checkbox
                            class="ml-2"
                            v-for="(item, index) in gestaoDeAula.disciplinas"
                            :key="index"
                            v-model="dadosAulas[h.id].disciplinasMarcadas"
                            :label="item?.descricao"
                            :value="item.id"
                          ></v-checkbox>
                        </div>
                      </div>
                    </div>

                    <div v-if="!disciplinaEspecial && dadosAulas[h.id]">
                      <ValidationProvider
                        :vid="'unidades_tematicas_' + h.id"
                        :name="'Unidades Temáticas'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>UNIDADES TEMÁTICAS</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].unidades_tematicas"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>
                    </div>

                    <div v-if="!disciplinaEspecial && dadosAulas[h.id]">
                      <ValidationProvider
                        :vid="'objeto_conhecimento_' + h.id"
                        :name="'Objeto do Conhecimento'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>OBJETOS DO CONHECIMENTO</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].objeto_conhecimento"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>
                    </div>

                    <div v-if="!disciplinaEspecial && dadosAulas[h.id]">
                      <ValidationProvider
                        v-if="outrosCampos"
                        :vid="'habilidades_' + h.id"
                        :name="'Habilidades'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>HABILIDADES</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].habilidades"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>
                    </div>

                    <template v-if="dadosAulas[h.id]">
                      <ValidationProvider
                        v-if="outrosCampos"
                        :vid="'objetivo_de_aprendizagem_' + h.id"
                        :name="'OBJETIVO DE APRENDIZAGEM'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>OBJETIVO DE APRENDIZAGEM</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].objetivo_de_aprendizagem"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>

                      <ValidationProvider
                        v-if="outrosCampos"
                        :vid="'procedimentos_metodologicos_' + h.id"
                        :name="'PROCEDIMENTOS METODOLÓGICOS'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>PROCEDIMENTOS METODOLÓGICOS</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].procedimentos_metodologicos"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>

                      <ValidationProvider
                        v-if="outrosCampos"
                        :vid="'material_de_apoio_' + h.id"
                        :name="'MATERIAL DE APOIO'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>MATERIAL DE APOIO</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].material_de_apoio"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>

                      <ValidationProvider
                        v-if="outrosCampos"
                        :vid="'avaliacao_da_aula_' + h.id"
                        :name="'AVALIAÇÃO DA AULA'"
                        rules="required|max:4000"
                        v-slot="{ errors }"
                      >
                        <e-label>AVALIAÇÃO DA AULA</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="dadosAulas[h.id].avaliacao_da_aula"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        ></v-textarea>
                      </ValidationProvider>
                    </template>
                  </div>
                </v-tab-item>
              </v-tabs-items>

              <div v-else>
                <div cols="12" v-if="!editing">
                  <div v-if="gestaoDeAula.is_polivalencia">
                    <e-label>Selecione as Disciplinas dessa Aula</e-label>
                    <div class="container">
                      <div class="row">
                        <v-checkbox
                          class="ml-2"
                          v-for="(item, index) in gestaoDeAula.disciplinas"
                          :key="index"
                          v-model="aulaSelecionada.disciplinasMarcadas"
                          :label="item?.descricao"
                          :value="item.id"
                        ></v-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <v-col cols="12" v-else>
                  <div v-if="aulaSelecionada.disciplinas?.length">
                    <div class="row mb-2">
                      <e-label>Disciplinas dessa Aula</e-label>
                    </div>
                    <div class="container">
                      <div class="row">
                        <div v-for="(item, index) in aulaSelecionada.disciplinas" :key="index">
                          <v-chip x-small>{{ getNomeDisciplina(item) }} </v-chip>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>

                <div cols="12" v-if="!disciplinaEspecial">
                  <ValidationProvider
                    name="Unidades Temáticas"
                    rules="required|max:4000"
                    v-slot="{ errors }"
                  >
                    <e-label>UNIDADES TEMÁTICAS</e-label>
                    <v-textarea
                      solo
                      dense
                      v-model="aulaSelecionada.unidades_tematicas"
                      :error-messages="errors"
                      :maxlength="4000"
                      :counter="true"
                    >
                      <template v-slot:counter>
                        {{ (aulaSelecionada.unidades_tematicas || "").length }}/4000
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </div>

                <div cols="12" v-if="!disciplinaEspecial">
                  <ValidationProvider
                    name="Objeto do Conhecimento"
                    rules="required|max:4000"
                    v-slot="{ errors }"
                  >
                    <e-label>OBJETOS DO CONHECIMENTO</e-label>
                    <v-textarea
                      solo
                      dense
                      v-model="aulaSelecionada.objeto_conhecimento"
                      :error-messages="errors"
                      :maxlength="4000"
                      :counter="true"
                    >
                      <template v-slot:counter>
                        {{ (aulaSelecionada.objeto_conhecimento || "").length }}/4000
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </div>

                <div cols="12" v-if="!disciplinaEspecial">
                  <ValidationProvider
                    v-if="outrosCampos"
                    name="Habilidades"
                    rules="required|max:4000"
                    v-slot="{ errors }"
                  >
                    <e-label>HABILIDADES</e-label>
                    <v-textarea
                      solo
                      dense
                      v-model="aulaSelecionada.habilidades"
                      :error-messages="errors"
                      :maxlength="4000"
                      :counter="true"
                      @input="habilidadesTextoEditado = true"
                    >
                      <template v-slot:counter>
                        {{ (aulaSelecionada.habilidades || "").length }}/4000
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </div>

                <ValidationProvider
                  v-if="outrosCampos"
                  name="OBJETIVO DE APRENDIZAGEM"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <e-label>OBJETIVO DE APRENDIZAGEM</e-label>
                  <v-textarea
                    solo
                    dense
                    v-model="aulaSelecionada.objetivo_de_aprendizagem"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.objetivo_de_aprendizagem || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <ValidationProvider
                  v-if="outrosCampos"
                  name="PROCEDIMENTOS METODOLÓGICOS"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <e-label>PROCEDIMENTOS METODOLÓGICOS</e-label>
                  <v-textarea
                    solo
                    dense
                    v-model="aulaSelecionada.procedimentos_metodologicos"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.procedimentos_metodologicos || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <ValidationProvider
                  v-if="outrosCampos"
                  name="MATERIAL DE APOIO"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <e-label>MATERIAL DE APOIO</e-label>
                  <v-textarea
                    solo
                    dense
                    v-model="aulaSelecionada.material_de_apoio"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.material_de_apoio || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <ValidationProvider
                  v-if="outrosCampos"
                  name="AVALIAÇÃO DA AULA"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <e-label>AVALIAÇÃO DA AULA</e-label>
                  <v-textarea
                    solo
                    dense
                    v-model="aulaSelecionada.avaliacao_da_aula"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.avaliacao_da_aula || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </div>

              <v-btn
                v-if="outrosCampos"
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                @click="tipoEnvio = 'salvar'"
                type="submit"
                >Enviar Dados</v-btn
              >

              <v-tooltip v-if="outrosCampos && !editing" :disabled="!aulaEmDataFutura()" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-inline-block" v-bind="attrs" v-on="on">
                    <v-btn
                      color="primary"
                      class="ml-3"
                      :disabled="submittingForm || aulaEmDataFutura()"
                      :loading="submittingForm"
                      @click="tipoEnvio = 'frequencia'"
                      type="submit"
                      >Enviar Dados e Lançar Frequência</v-btn
                    >
                  </div>
                </template>
                <span>
                  Esta frequência só poderá ser lançada na mesma data ou superior em que a aula foi
                  criada
                </span>
              </v-tooltip>

              <v-btn
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.duplicar = true"
                >Duplicar Aula</v-btn
              >
              <v-btn
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <v-row v-if="etapas?.length === 0 && etapaBloqueada == false">
          <v-col cols="12">
            <v-alert type="warning" border="left">
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaBloqueada == true && etapaPendente == false">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Atenção essa etapa está bloqueada, para lançar aulas você deve solicitar uma
              autorização, clicando no botão acima
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaPendente == true">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Aguarde, já existe um pedido de autorização para essa etapa e estamos analisando.
            </v-alert>
            <v-btn class="success" @click="verPedidos">Acompanhe seus pedidos</v-btn>
          </v-col>
        </v-row>

        <div v-if="etapas?.length > 0 && etapaBloqueada == false && etapaSelecionada">
          <v-row
            v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado"
          >
            <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
            </v-col>
          </v-row>
        </div>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma?.franquia?.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma?.descricao }}</td>
                  <td>{{ item.disciplina?.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir em
      Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o responsável
      realizar esse procedimento.</v-alert
    >
    <e-modal-duplicar-aula
      v-if="aulaSelecionada.disciplinas"
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      :disciplinas="aulaSelecionada.disciplinas"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-duplicar-aula
      v-else
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    horariosComDados() {
      const selecionados = this.getHorariosArray();
      return selecionados.filter((h) => this.dadosAulas[h.id]);
    },
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      return (this.todosEventos || [])
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2], 10) - parseInt(b.data.split("-")[2], 10);
        });
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
    this.carregarFeriados();
  },
  data() {
    return {
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      text: "",
      textColor: "#000000",
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      autorizacao: [],
      mostrarEtapas: false,
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      turma: null,
      data: null,
      modal: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: false,
      outrosCampos: false,
      submittingForm: false,
      carregandoDados: false,
      form: {},
      aulaSelecionada: {
        data: null,
        habilidades: "",
        unidades_tematicas: "",
        objeto_conhecimento: "",
        replicar_conteudo: true,
        disciplinasMarcadas: [],
        arrayConteudos: [],
        conteudos: {},
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: this.editing ? null : [],
      arrayConteudoEditar: [],
      mesVisivel: null,
      feriados: [],
      eventos: [],
      sabadosLetivos: [],
      todosEventos: [],
      disciplinaPertenceAoBncc: false,
      disciplinaEspecial: false,
      turmaComSistemaBncc: false,
      habilidadesBncc: null,
      habilidadesJsonOriginal: null,
      habilidadesTextoEditado: false,
      activeTab: 0,
      dadosAulas: {},
      tipoEnvio: "salvar",
    };
  },
  watch: {
    horarioSelecionado(newVal) {
      if (!this.editing) {
        if (!newVal || newVal.length === 0) {
          this.dadosAulas = {};
          this.aulaSelecionada.unidades_tematicas = "";
          this.aulaSelecionada.objeto_conhecimento = "";
          this.aulaSelecionada.habilidades = "";
          this.aulaSelecionada.objetivo_de_aprendizagem = "";
          this.aulaSelecionada.procedimentos_metodologicos = "";
          this.aulaSelecionada.material_de_apoio = "";
          this.aulaSelecionada.avaliacao_da_aula = "";
        } else if (this.dadosAulas) {
          const selectedIds = newVal.map((h) => h.id);
          Object.keys(this.dadosAulas).forEach((id) => {
            if (!selectedIds.includes(parseInt(id, 10))) {
              this.$delete(this.dadosAulas, id);
            }
          });
        }
      }

      const selecionados = this.getHorariosArray(newVal);
      if (selecionados.length > 0) {
        selecionados.forEach((h) => {
          if (!this.dadosAulas[h.id]) {
            this.$set(this.dadosAulas, h.id, {
              unidades_tematicas: this.aulaSelecionada.unidades_tematicas || "",
              objeto_conhecimento: this.aulaSelecionada.objeto_conhecimento || "",
              habilidades: this.aulaSelecionada.habilidades || "",
              objetivo_de_aprendizagem: this.aulaSelecionada.objetivo_de_aprendizagem || "",
              procedimentos_metodologicos: this.aulaSelecionada.procedimentos_metodologicos || "",
              material_de_apoio: this.aulaSelecionada.material_de_apoio || "",
              avaliacao_da_aula: this.aulaSelecionada.avaliacao_da_aula || "",
              disciplinasMarcadas: [...(this.aulaSelecionada.disciplinasMarcadas || [])],
              conteudos: { ...(this.aulaSelecionada.conteudos || {}) },
              arrayConteudos: [...(this.aulaSelecionada.arrayConteudos || [])],
            });
          }
        });
      }
    },
    "aulaSelecionada.replicar_conteudo": function () {
      if (!this.editing) {
        this.aulaSelecionada.unidades_tematicas = "";
        this.aulaSelecionada.objeto_conhecimento = "";
        this.aulaSelecionada.habilidades = "";
        this.aulaSelecionada.objetivo_de_aprendizagem = "";
        this.aulaSelecionada.procedimentos_metodologicos = "";
        this.aulaSelecionada.material_de_apoio = "";
        this.aulaSelecionada.avaliacao_da_aula = "";

        const newDadosAulas = {};
        if (!this.aulaSelecionada.replicar_conteudo && this.horarioSelecionado?.length > 0) {
          this.horarioSelecionado.forEach((h) => {
            newDadosAulas[h.id] = {
              unidades_tematicas: "",
              objeto_conhecimento: "",
              habilidades: "",
              objetivo_de_aprendizagem: "",
              procedimentos_metodologicos: "",
              material_de_apoio: "",
              avaliacao_da_aula: "",
              disciplinasMarcadas: [],
              conteudos: {},
              arrayConteudos: [],
            };
          });
        }
        this.dadosAulas = newDadosAulas;
      }
    },
    "aulaSelecionada.disciplinasMarcadas": function (val) {
      const arrayConvert = [];
      val.forEach((element) => {
        const valor = this.gestaoDeAula.disciplinas.filter((dado) => dado.id === element);
        arrayConvert.push(valor[0]);
      });
      this.atualizarTopicos(arrayConvert);
    },
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = [];
      }
    },
    data(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");

      this.pesquisaAulas();

      const diaDaSemana = new Date(value).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana, value).then(() => {
        const selecionados = this.getHorariosArray();

        if (this.editing && selecionados.length > 0) {
          const IDsSelecionados = selecionados.map((h) => h.id);
          const novosHorariosSelecionados = this.horarios.filter((h) =>
            IDsSelecionados.includes(h.id)
          );
          if (novosHorariosSelecionados.length > 0) {
            this.horarioSelecionado = this.editing
              ? novosHorariosSelecionados[0]
              : novosHorariosSelecionados;
          }
        }
      });
    },
  },
  methods: {
    aulaEmDataFutura() {
      return this.$ehAulaFutura(this.aulaSelecionada.data);
    },
    parseHabilidadesJson(value) {
      if (!value) return null;
      if (Array.isArray(value)) return value;
      if (typeof value !== "string") return null;
      const trimmed = value.trim();
      if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) return null;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : null;
      } catch (error) {
        return null;
      }
    },
    formatHabilidadesTexto(lista) {
      if (!Array.isArray(lista) || lista.length === 0) return "";
      return lista
        .map((h) => {
          const apelido = h?.apelido ? `[${h.apelido}] ` : "";
          const descricao = h?.descricao || "";
          return `${apelido}${descricao}`.trim();
        })
        .filter((item) => item)
        .join("\n");
    },
    formatUnidadesTexto(lista) {
      if (!Array.isArray(lista) || lista.length === 0) return "";
      const unidades = lista
        .map((h) => h?.unidades_tematicas || h?.praticas_linguagem)
        .filter(Boolean);
      return [...new Set(unidades)].join("\n");
    },
    formatObjetosTexto(lista) {
      if (!Array.isArray(lista) || lista.length === 0) return "";
      const objetos = lista.map((h) => h?.objeto_conhecimento).filter(Boolean);
      return [...new Set(objetos)].join("\n");
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana, dataSelecionada = this.data) {
      const toYMD = (v) => {
        if (!v) return "";
        if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
        const d = v instanceof Date ? v : new Date(v);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate()
        ).padStart(2, "0")}`;
      };

      const dataFormatada = toYMD(dataSelecionada);
      const evento = (this.todosEventos || []).find((ev) => toYMD(ev.data) === dataFormatada);

      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
            await this.buscarTodosHorarios();
          }

          this.horarios = this.todosHorariosDisponiveis || [];
          this.horariosDoComponente = this.todosHorariosDisponiveis.map((h) => ({
            id: h.id,
            descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
            inicio: h.inicio,
            final: h.final,
            turno_id: h.turno_id,
          }));
          return;
        }

        if (evento.is_letivo === true || evento.is_letivo === 1) {
          const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
            .filter((r) => r.dia.id === diaDaSemana)
            .map((r) => r.horario);
          this.horarios = horariosDoDia;
          this.horariosDoComponente = horariosDoDia;
          return;
        }
        if (!this.editing) {
          this.horarios = [];
          this.horariosDoComponente = [];
        }
        return;
      }

      if (!this.gestaoDeAula?.relacoesDiasHorarios) {
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);

      this.horarios = horariosDoDia;
      this.horariosDoComponente = horariosDoDia;
    },
    getNomeDisciplina(id) {
      const dis = this.gestaoDeAula.disciplinas.filter((obj) => obj.id === id);
      return dis[0].descricao;
    },
    editarConteudoPoli(index, $event) {
      this.aulaSelecionada.arrayConteudos[index] = $event;
    },
    getConteudoPolivalencia() {
      this.aulaSelecionada.disciplinas.forEach((element, index) => {
        this.arrayConteudoEditar.push(
          JSON.parse(this.aulaSelecionada.conteudo_polivalencia)[index]
        );
      });

      this.arrayConteudoEditar.forEach((element, index) => {
        const obj = {
          id: this.aulaSelecionada.disciplinas[index],
          content: element,
        };
        this.aulaSelecionada.arrayConteudos.push(obj);
      });
    },
    atualizarTopicos(array) {
      this.aulaSelecionada.arrayConteudos = [];
      array.forEach((element) => {
        this.aulaSelecionada.arrayConteudos.push(element);
      });
    },
    updateText(event) {
      this.text = event.target.innerHTML;
    },
    executeCommand(command) {
      document.execCommand(command, false, null);
    },

    changeFont(size) {
      document.execCommand("fontSize", false, "7");
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const node = document.createElement("span");
        node.style.fontSize = size;
        range.surroundContents(node);
      }
    },
    changeStyle(style) {
      document.execCommand(style, false, null);
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const node = document.createElement("span");
        node.style.fontStyle = style === "italic" ? style : null;
        node.style.fontWeight = style === "bold" ? style : null;
        node.style.textDecoration = style === "underline" ? style : null;
        range.surroundContents(node);
      }
    },
    setTextColor() {
      this.executeCommand("foreColor", this.textColor);
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    dateFormatConvert(data) {
      return dateFormatParam(data);
    },
    verificarEtapaSelecionada() {
      this.aulaSelecionada.data = null;
      this.horarioSelecionado = [];
      this.data = null;
      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = dateFormatParam(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_final;
      this.fimPeriodoEtapa = dateFormatParam(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada.id).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
      this.getDisciplinaEHabilidades();
    },
    async pesquisaAulas() {
      const data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
      const { aula_id } = this.$route.params;
      const turma_id = this.gestaoDeAula.turma.id;

      const selecionados = this.getHorariosArray();

      if (!data_aula || selecionados.length === 0 || !this.aulaSelecionada) return;

      this.aulasConflitadas = [];

      try {
        const promessas = selecionados.map((horario) =>
          this.$services.aulasService.pesquisarAulasEmConflitos(
            data_aula,
            horario.id,
            turma_id,
            aula_id
          )
        );

        const resultados = await Promise.all(promessas);
        let temConflito = false;

        resultados.forEach((response) => {
          if (response.data?.length > 0) {
            this.aulasConflitadas = [...this.aulasConflitadas, ...response.data];
            temConflito = true;
          }
        });

        if (!temConflito) {
          this.mostrarCampos = true;
          this.outrosCampos = true;
        } else {
          this.aulasEmConflitos = true;
          this.outrosCampos = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      await this.getHorarios();
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async onFormSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.submitForm();
      } else {
        const errors = this.$refs.observer.errors;
        const vidsWithErrors = Object.keys(errors).filter((vid) => errors[vid].length > 0);

        if (vidsWithErrors.length > 0) {
          const firstVidWithHorario = vidsWithErrors.find((vid) => /_(\d+)$/.test(vid));

          if (firstVidWithHorario) {
            const match = firstVidWithHorario.match(/_(\d+)$/);
            if (match) {
              const horarioId = parseInt(match[1], 10);
              const index = this.horariosComDados.findIndex((h) => h.id === horarioId);
              if (index !== -1) {
                this.activeTab = index;
              }
            }
          }
        }
      }
    },
    async submitForm() {
      const payload = { ...this.aulaSelecionada };

      const hSelecionado = this.getHorariosArray();

      if (this.editing) {
        const arrayParaEditar = [...this.aulaSelecionada.arrayConteudos];
        arrayParaEditar.forEach((element, index) => {
          if (typeof element !== "string") {
            arrayParaEditar[index] = element.content;
          }
        });
        payload.conteudo_polivalencia = JSON.stringify(arrayParaEditar);

        payload.horarios = hSelecionado.map((h) => ({
          id: h.id,
          inicio: h.inicio,
          final: h.final,
        }));

        const horario = hSelecionado[0];
        payload.horario_inicial = horario ? horario.inicio : null;
        payload.horario_final = horario ? horario.final : null;
        payload.horario_id = horario ? horario.id : null;
      } else {
        payload.horarios = hSelecionado.map((h) => {
          const dadosH = this.aulaSelecionada.replicar_conteudo
            ? this.aulaSelecionada
            : this.dadosAulas[h.id];

          let conteudoPoli = null;
          if (this.gestaoDeAula.is_polivalencia) {
            const arr = [];
            const dMarcadas = dadosH.disciplinasMarcadas || [];
            dMarcadas.forEach((element) => {
              arr.push(dadosH.conteudos[element]);
            });
            conteudoPoli = JSON.stringify(arr);
          }

          return {
            id: h.id,
            inicio: h.inicio,
            final: h.final,
            unidades_tematicas: dadosH.unidades_tematicas,
            objeto_conhecimento: dadosH.objeto_conhecimento,
            habilidades: dadosH.habilidades,
            objetivo_de_aprendizagem: dadosH.objetivo_de_aprendizagem,
            procedimentos_metodologicos: dadosH.procedimentos_metodologicos,
            material_de_apoio: dadosH.material_de_apoio,
            avaliacao_da_aula: dadosH.avaliacao_da_aula,
            disciplinas: dadosH.disciplinasMarcadas,
            conteudo_polivalencia: conteudoPoli,
          };
        });

        if (this.aulaSelecionada.replicar_conteudo) {
          payload.disciplinas = this.aulaSelecionada.disciplinasMarcadas;
        }
      }

      if (this.habilidadesJsonOriginal && !this.habilidadesTextoEditado) {
        payload.habilidades = JSON.stringify(this.habilidadesJsonOriginal);
      }

      payload.etapa_id = this.etapaSelecionada.id;

      this.submittingForm = true;
      try {
        if (this.editing) {
          payload.instrutorDisciplinaTurma_id = parseInt(this.$route.params.gestaoDeAulaId, 10);
          payload.data = payload.data.split("/").reverse().join("-");
          await this.$services.aulasService.atualizar(payload);
          this.$toast.success("Aula editada com sucesso!");
          this.$router.back();
        } else {
          payload.instrutorDisciplinaTurma_id = parseInt(this.$route.params.gestaoDeAulaId, 10);
          payload.disciplina_id = this.gestaoDeAula.disciplina_id;
          payload.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          payload.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          payload.data = payload.data.split("/").reverse().join("-");

          const response = await this.$services.aulasService.criar(payload);

          if (this.tipoEnvio === "frequencia") {
            const aulas = Array.isArray(response) ? response : [response];
            const ids = aulas.map((a) => a.id).join(",");
            this.$toast.success("Aula(s) salva(s). Redirecionando para frequência...");
            this.$router.push({
              name: "aulas.frequencia-lote",
              params: {
                gestaoDeAulaId: this.$route.params.gestaoDeAulaId,
                aula_ids: ids,
              },
            });
          } else {
            this.$toast.success("Aula(s) cadastrada(s) com sucesso!");
            this.$router.back();
          }
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    async getAula() {
      await this.getHorarios();
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.turma = response.payload.gestaoDeAula.turma;
      this.gestaoDeAula = response.payload.gestaoDeAula;
      const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;
      this.horariosSabado = response.payload.horarios.filter((h) => h.turno_id === turnoIdTurma);
      const aulaData = await this.$services.aulasService.getAula(parseInt(aula_id, 10));

      if (this.editing) {
        this.horarioSelecionado = aulaData.horario;
      } else {
        this.horarioSelecionado = aulaData.horario ? [aulaData.horario] : [];
      }

      this.text = aulaData.conteudo;
      this.data = aulaData.data;

      const habilidadesJson = this.parseHabilidadesJson(aulaData.habilidades);
      if (habilidadesJson) {
        this.habilidadesJsonOriginal = habilidadesJson;
        this.habilidadesTextoEditatedo = false;
        aulaData.habilidades = this.formatHabilidadesTexto(habilidadesJson);
        if (!aulaData.unidades_tematicas) {
          aulaData.unidades_tematicas = this.formatUnidadesTexto(habilidadesJson);
        }
        if (!aulaData.objeto_conhecimento) {
          aulaData.objeto_conhecimento = this.formatObjetosTexto(habilidadesJson);
        }
      } else {
        this.habilidadesJsonOriginal = null;
        this.habilidadesTextoEditatedo = false;
      }
      if (!aulaData.habilidades) {
        aulaData.habilidades = "";
      }

      const diaSemana = new Date(this.data).getDay();

      await this.filtrarHorariosPorDiaDaSemana(diaSemana, this.data);

      const selecionados = this.getHorariosArray();

      if (this.editing && selecionados.length > 0 && this.horarios) {
        const selectedHorario = selecionados[0];
        const horarioExists = this.horarios.some((h) => h.id === selectedHorario.id);
        if (!horarioExists) {
          this.horarios.push(selectedHorario);
        }
      }

      // Garante que campos obrigatórios existam após carga da API
      aulaData.disciplinasMarcadas = aulaData.disciplinasMarcadas || [];
      aulaData.arrayConteudos = aulaData.arrayConteudos || [];
      aulaData.conteudos = aulaData.conteudos || {};
      aulaData.replicar_conteudo = true;

      return aulaData;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        // Inicializa estado padrão se estiver criando
        if (!this.editing) {
          this.aulaSelecionada.disciplinasMarcadas = [];
          this.aulaSelecionada.arrayConteudos = [];
          this.aulaSelecionada.conteudos = {};
          this.aulaSelecionada.replicar_conteudo = true;
        }

        await this.getHorarios();
        this.aulaSelecionada = await this.getAula();
        if (this.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId,
            "aulas"
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.etapas.forEach((element) => {
            this.verificarSeTemPedido(element.id);
          });

          if (this.editing) {
            this.getEtapa();
          }
        }
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }

        this.turmaComSistemaBncc = !!this.gestaoDeAula.turma?.sistema_bncc_id;

        await this.getDisciplinaEHabilidades();

        this.$forceUpdate();

        if (this.editing) this.getConteudoPolivalencia();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();
        this.todosHorariosDisponiveis = response.data || response;
        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },

    async getHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
          this.$route.params.gestaoDeAulaId
        );

        this.gestaoDeAula = response.payload.gestaoDeAula;

        const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;
        await this.buscarTodosHorarios();

        this.horariosSabado = response.payload.horarios
          .filter((h) => h.turno_id === turnoIdTurma)
          .map((h) => ({
            id: h.id,
            turno_id: h.turno_id,
            descricao: h.descricao.split(" - ")[0],
            final: h.final,
            inicio: h.inicio,
          }));

        if (this.gestaoDeAula.relacoesDiasHorarios) {
          this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
            (g) => g.dia.id
          );

          this.horariosDaGestao = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
          this.horarios = this.horariosDaGestao;
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar informações de horários");
      }
    },

    async getDisciplinaEHabilidades() {
      if (!this.etapaSelecionada || !this.etapaSelecionada.id) return;

      this.disciplinaPertenceAoBncc = this.gestaoDeAula.disciplina.is_bncc;
      this.disciplinaEspecial = this.gestaoDeAula.disciplina.is_especial;

      const response = await this.$services.gestoesDeAulasService.getDisciplinaEHabilidades(
        this.gestaoDeAula.id,
        this.etapaSelecionada.id,
        this.gestaoDeAula.disciplina_id
      );

      this.sistemaBnnc = response.sistema_bncc;
      this.habilidadesBncc = response.habilidades_bncc;
      this.habilidadesSaeb = response.habilidades_saeb ?? [];
    },

    allowedDates(val) {
      let dataFormatada;
      if (typeof val === "string") {
        dataFormatada = val.length > 10 ? val.slice(0, 10) : val;
      } else {
        dataFormatada = new Date(val).toISOString().split("T")[0];
      }

      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === dataFormatada;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return true;
        }
        return false;
      }
      const ehFeriado = this.feriados.some((feriado) => {
        const fData = feriado.data.length > 10 ? feriado.data.slice(0, 10) : feriado.data;
        return fData === dataFormatada;
      });
      if (ehFeriado) return true;

      const diaDaSemana = new Date(dataFormatada).getDay();
      if (!this.diasPermitidosParaCriarAula.includes(diaDaSemana)) return false;

      return true;
    },

    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();

        this.todosEventos = response.map((evento) => ({
          data: evento.start,
          descricao: evento.descricao,
          cor: evento.color,
          is_feriado: evento.evento.is_feriado,
          is_sabado_letivo: evento.evento.is_sabado_letivo,
        }));
        this.feriados = this.todosEventos.filter((evento) => evento.is_feriado === true);
        this.sabadosLetivos = this.todosEventos.filter(
          (evento) => evento.is_sabado_letivo === true
        );
      } catch (error) {
        this.$handleError(error);
      }
    },
    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
    },
    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },
    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },
    isSabadoLetivo(date) {
      return this.sabadosLetivos.some((s) => s.data === date);
    },
    getBadgeColor(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        return (
          evento.cor ||
          (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1 ? "green" : "red")
        );
      }
      if (this.isFeriado(date)) return "red";
      return "";
    },
    getBadgeContent(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return "Letivo";
        }
        return "Dia não letivo";
      }
      if (this.isFeriado(date)) return "F";
      return "";
    },
    getEventColor(date) {
      const cores = [];
      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) cores.push(feriado.cor);
      const sabado = this.sabadosLetivos.find((s) => s.data === date);
      if (sabado) cores.push(sabado.cor);
      return cores.length > 0 ? cores : "red";
    },
    getEtapa() {
      let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
      etapa = etapa.shift();
      this.fimPeriodoEtapa = etapa.periodo_final;
      this.inicioPeriodoEtapa = etapa.periodo_inicial;
      this.etapaSelecionada = etapa;
    },
    criarPedido(etapaId) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: etapaId } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        this.etapaBloqueada = false;
      } else {
        this.etapaBloqueada = true;
      }
      if (this.idsEtapasPendentes.includes(etapa.id)) {
        this.etapaPendente = true;
      } else {
        this.etapaPendente = false;
      }
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(etapaId);

      if (response.data.aprovados?.length) {
        this.idsEtapasDisponivels.push(etapaId);
      }

      if (response.data.pendentes?.length) {
        this.idsEtapasPendentes.push(etapaId);
      }
    },
    beforeDestroy() {
      if (this.$refs.editor) {
        this.text = this.$refs.editor.innerHTML;
      }
    },

    habilidadesSiglasFilter(item, queryText, itemText) {
      const text = `${item.descricao} ${item.apelido}`.toLowerCase();
      return text.includes(queryText.toLowerCase());
    },

    quantidadeNecessariaParaReplicar() {
      if (this.horarioSelecionado.length > 1) {
        return true;
      }

      return false;
    },

    getFieldsObject(horarioId) {
      if (this.aulaSelecionada.replicar_conteudo || !horarioId) {
        return this.aulaSelecionada;
      }
      return this.dadosAulas[horarioId];
    },

    updateFieldsValue(horarioId, field, value) {
      if (this.aulaSelecionada.replicar_conteudo || !horarioId) {
        this.$set(this.aulaSelecionada, field, value);
      } else {
        this.$set(this.dadosAulas[horarioId], field, value);
      }
    },

    getHorariosArray(val = this.horarioSelecionado) {
      if (Array.isArray(val)) return val;
      if (val) return [val];
      return [];
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}
.dialog-actions {
  padding: 16px;
  justify-content: flex-end;
}
</style>
